import script from "./Applys.vue?vue&type=script&lang=ts&setup=true"
export * from "./Applys.vue?vue&type=script&lang=ts&setup=true"

import "./Applys.vue?vue&type=style&index=0&id=768a8163&lang=scss"

const __exports__ = script;

export default __exports__